import React, { useState } from "react";
import splitter1 from "../images/splitter1.jpeg";

function SplitterImage({ borderStyles = "border-custom-yellow" }) {
    const [isLoading, setIsLoading] = useState(true);
    return (
        <>
            {isLoading ? (
                <div
                    className={`w-full flex justify-center items-center border-y-2 ${borderStyles} lg:h-[438px]`}
                >
                    <img
                        src="https://i.imgur.com/kMU7q8Q.gif"
                        width={100}
                        alt="loading"
                    />
                </div>
            ) : null}
            <img
                src={splitter1}
                alt="splitter"
                onLoad={() => setIsLoading(false)}
                loading="lazy"
                decoding="async"
                className={`w-full border-y-2 ${borderStyles} lg:h-[438px] object-cover object-top ${
                    isLoading ? "hidden" : "block"
                }`}
            />
        </>
    );
}

export default SplitterImage;
